import { useCallback, useState } from 'react';
import { NodeConnection } from '../../types/workflow';
import { useGetNodeConnectionsByWorkflowId } from '../../api/nodeApi';
import { useWorkflowId } from '../../utils/misc';

const useNodeConnections = () => {
    const [nodeConnections, setNodeConnections] = useState<NodeConnection[]>([]);
    const workflowId = useWorkflowId();
    const { mutate: getNodeConnectionsByWorkflowId } = useGetNodeConnectionsByWorkflowId();

    const fetchNodeConnections = useCallback(() => {
        if (workflowId) {
            getNodeConnectionsByWorkflowId({ workflowId }, {
                onSuccess: (connections) => {
                    setNodeConnections(connections);
                }
            });
        }
    }, [workflowId, getNodeConnectionsByWorkflowId]);

    const addNodeConnection = (newConnection: NodeConnection) => {
        setNodeConnections(prev => [...prev, newConnection]);
    };

    const removeNodeConnection = (connectionId: string) => {
        setNodeConnections(prev => prev.filter(conn => conn.id !== connectionId));
    };

    const updateNodeConnection = (updatedConnection: NodeConnection) => {
        setNodeConnections(prev => 
            prev.map(conn => conn.id === updatedConnection.id ? updatedConnection : conn)
        );
    };

    return {
        nodeConnections,
        setNodeConnections,
        fetchNodeConnections,
        addNodeConnection,
        removeNodeConnection,
        updateNodeConnection
    };
};

export default useNodeConnections; 